import { Routes } from '@angular/router';
import { InicioComponent } from './shared/components/inicio/inicio.component';
import { ProductosComponent } from './shared/components/productos/productos.component';
import { ArticulospromocionalesComponent } from './shared/components/articulospromocionales/articulospromocionales.component';
import { NosotrosComponent } from './shared/components/nosotros/nosotros.component';

export const routes: Routes = [
  { path: 'inicio', component: InicioComponent }, // Ruta para el componente Inicio
  { path: 'productos', component: ProductosComponent }, // Ruta para el componente Productos
  { path: 'articulospromocionales', component: ArticulospromocionalesComponent }, // Ruta para el componente Artículos Promocionales
  { path: 'nosotros', component: NosotrosComponent }, // Ruta para el componente Nosotros
  { path: '', redirectTo: 'inicio', pathMatch: 'full' }, // Redirige a 'inicio' 
  { path: '**', redirectTo: 'inicio' }  // Redirige cualquier ruta desconocida a 'inicio'
];
